<template>
  <framed-layout>

    <template #center>
      <h3 class="font-bold">Kutsu Iffentiga liituma</h3>
    </template>

    <template #right>
      <a @click="$router.go(-1)" class="btn-circle cursor-pointer">
        <i class="text-xl text-blue-500 pi pi-times"></i>
      </a>
    </template>

    <div class="max-w-xl mx-auto flex flex-col justify-between">
      <div class="mb-8 mt-32 md:mt-40">
        <div class="w-full p-float-label mb-10">
          <div class="flex-1 p-float-label">
            <input-text
                required
                id="email"
                type="email"
                placeholder=" "
                v-model="email"
                :use-grouping="false"
                :class="{ 'p-invalid': invalid }"
                class="w-full"
                @input="invalid = false"
            />
            <label for="email">E-mail</label>
            <small v-if="invalid" id="email-help" class="text-red-500">Email ei ole korrektne.</small>
          </div>

          <div class="my-12 text-center">
            <button class="w-56 text-white bg-orange-400 btn"
                    :class="{ 'p-disabled': invalid || !email }"
                    @click="submit">Kutsu</button>
          </div>
        </div>
      </div>
    </div>

  </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import validEmail from "@/utils/validEmail";
import { invite } from "@/store/referral.api";

export default {
  components: {
    FramedLayout
  },
  data() {
    return {
      email: null,
      invalid: false,
    }
  },
  async mounted() {

  },
  methods: {
    submit() {
      if (!validEmail(this.email)) {
        this.invalid = true;
      } else {
        this.invalid = false;

        let payload = {
          email: this.email,
          projectUserId: this.$route.params.projectUserId,
        };
        invite(payload).then(() => {
          setTimeout(() => {
            this.showToast('Kutse saadetud', 'success');
          }, 100);
          this.$router.go(-1);
        }, (error) => {
          const toast = error.response?.data;
          if (toast) {
            this.processAxiosPositiveResponse(toast);
          } else {
            this.showToast('Kutse saatmine ebaõnnestus', 'error');
          }
        })
      }
    },
  }
}
</script>